import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectActiveVenue } from 'selectors/general';

import { SKU_VENUE_SOURCE, getSkuVenueSource } from './SkuVenueSource.helpers';
import messages from './useSkuVenuePermissions.messages';

const INTEGRATION_DISPLAY_NAMES = {
  SQUARE_PRODUCT: 'Square',
};

const useSkuVenuePermissions = () => {
  const intl = useIntl();
  const venue = useSelector(selectActiveVenue);
  const source = getSkuVenueSource(venue);
  const isManual = source === SKU_VENUE_SOURCE.MANUAL;

  return {
    canAddItem: isManual,
    canEditItem: isManual,
    canAddCategory: isManual,
    canEditCategory: isManual,
    canAddMenu: isManual,
    canEditMenu: isManual,
    isManual,
    isIntegrated: !isManual,
    source,
    integrationName:
      INTEGRATION_DISPLAY_NAMES[venue?.venueSource] ||
      (isManual ? '' : intl.formatMessage(messages.genericIntegrationName)),
  };
};

export default useSkuVenuePermissions;
